import { useThemeContext } from '@huggg/react-components';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Legal = (props) => {
  const { operator } = useThemeContext();
  const className = classnames('legal', props.className);

  return <div className={className}>{operator.legal}</div>;
};

Legal.propTypes = {
  className: PropTypes.string,
};

export default Legal;
